// Libraries
var React = require('react');

// Components
var FeaturedSponsors = require('./FooterFeaturedSponsors');
var SecondarySponsors = require('./FooterSecondarySponsors');

class FooterSponsorsModule extends React.Component {
	render() {
		return (
			<div className="FooterSponsors">
				<div className="FooterSponsors__wrapper">
					<FeaturedSponsors data={this.props.data.featuredSponsors} />
					<SecondarySponsors data={this.props.data.secondarySponsors} />
				</div>	
			</div>	
		)
	}
}

module.exports = FooterSponsorsModule;


// WEBPACK FOOTER //
// ./src/components/Footer/Sponsors/FooterSponsorsModule.js